export enum SpfIcons {
  magnifyingGlass = 'magnifying-glass',
  sliders = 'sliders',
  board = 'board',
  space = 'space',
  page = 'page-icon',
  frontEnd = 'front-end',
  ball = 'ball',
  wrench = 'wrench',
}
